import React, { forwardRef, ComponentPropsWithoutRef } from "react";
import { ArrowRight } from "lucide-react";
import { cn } from "../utils";

interface InteractiveHoverButtonProps
  extends ComponentPropsWithoutRef<"button"> {
  hoverText?: string; // text to show on hover
}

export const InteractiveHoverButton = forwardRef<
  HTMLButtonElement,
  InteractiveHoverButtonProps
>(({ children, hoverText, className, ...props }, ref) => {
  return (
    <button
      ref={ref}
      className={cn(
        "group relative inline-flex items-center justify-center overflow-hidden rounded-full border px-14 py-3 text-2xl font-semibold transition-colors duration-300",
        "bg-background text-black hover:bg-black hover:text-white border-black",
        className
      )}
      {...props}
    >
      {/* Default State */}
      <span className="transition-all duration-300 group-hover:translate-x-12 group-hover:opacity-0">
        {children}
      </span>

      {/* Hover State */}
      <div className="absolute inset-0 flex items-center justify-center gap-2  opacity-0 transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-100 ">
        <span >{hoverText || children}</span>
        <ArrowRight className="mt-2" />
      </div>
    </button>
  );
});

InteractiveHoverButton.displayName = "InteractiveHoverButton";
